import React from 'react';

export const AspectFrame = ({ orientation = 'landscape', children, className = '', testId }) => {
  const ratio = orientation === 'portrait' ? 9 / 16 : 16 / 9;
  return (
    <div
      data-testid={testId}
      className={`relative w-full overflow-hidden rounded-[var(--radius-md)] border border-[hsl(var(--border-soft))] bg-[hsl(var(--bg-2))] crop-marks ${className}`}
      style={{ aspectRatio: String(ratio) }}
    >
      {children}
    </div>
  );
};
